import { QueryClient } from "@tanstack/solid-query";

export function getContext() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: 2,
      },
    },
  });
  return {
    queryClient,
  };
}
